module.exports = __webpack_public_path__ + "img/adorno.54bb1f9a.svg";